import type { EmailPreviewBody } from '@lotta/shared/types-lottery-api';
import { transformBody } from '../transform-body/transform-body';

type FormContent = {
  subjectLine: string;
  preHeader: string;
  bodyHeadline: string;
  ctaText: string;
  ctaLink: string;
  disclaimerText?: string;
  body: string;
  bannerImageUrl: string;
};

export const getPreviewEmailContent = (
  formContent: FormContent,
  language: string,
  market: string
) => {
  const {
    subjectLine = '',
    preHeader = '',
    bodyHeadline = '',
    ctaText = '',
    ctaLink = '',
    disclaimerText = '',
    body = '',
    bannerImageUrl = '',
  } = formContent;

  const transformedBody = transformBody(body);

  const previewEmailContent: EmailPreviewBody['emailContent'] = {
    market,
    language,
    customerId: 'CustomerID-123-456',
    profileType: 'FAMILY',
    customerCategory: 'LOYALTY',
    ikeaStoreId: '456',
    membershipCardNumber: '1111111111111111',
    subjectLine,
    preHeader,
    bodyHeadline,
    ctaText,
    ctaLink,
    disclaimerText,
    body: transformedBody,
    bannerImageUrl,
  };
  return previewEmailContent;
};
